module.exports = __webpack_public_path__ + "media/images/athletes/3575-61ab1cbd00c7660fcf06f0f94c0afc4d.png";